import { filterOptionsContract } from "#shared/reviewee-filters/filterOptionsContract.ts";
import { createORPCClient } from "@orpc/client";
import type { ContractRouterClient } from "@orpc/contract";
import { OpenAPILink } from "@orpc/openapi-client/fetch";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { apiFetch } from "@packages/core-client/api/apiFetch.ts";
import { queryPath } from "@packages/core-client/query/queryKeys.ts";
import { useEnvironmentVariable } from "@squide/firefly";
import { useMemo } from "react";

function createFilterOptionsClient(baseUrl: string) {
    const link = new OpenAPILink(filterOptionsContract, {
        url: `${baseUrl}/api/reviews/filter-options`,
        fetch: apiFetch
    });

    const client: ContractRouterClient<typeof filterOptionsContract> = createORPCClient(link);

    return createTanstackQueryUtils(client, { path: queryPath("admin-settings", ["members", "reviews"]) });
}

export function useFilterOptionsClient() {
    const apiBaseUrl = useEnvironmentVariable("apiBaseUrl");

    return useMemo(() => createFilterOptionsClient(apiBaseUrl), [apiBaseUrl]);
}
